<template>
  <div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
      <div class="form-group" style="display: flex; align-items: center; margin-top: 20px; width: 100%;">
        <div>Lista de variáveis disponíveis para utilizar na criação da regra de negócio</div>
         <span class="filters__search" style="margin-left: auto;">
          <input
            type="text"
            v-model="termo"
            placeholder="Buscar por ..."
            v-on:input="debounceLoadData()"
          />
            <fa-icon icon="search" />
         </span>
         <slot name="filter-search" />
      </div>
      
    </div>
    <div class="table-responsive binds-scroll">
      <datatable
        :columns="table.columns"
        :data="bindsFiltered"
        class="table table-hover"
      >
        <template slot-scope="{ row }">
            <tr>
              <td style="text-align: left">{{ row.bind }}</td>
              <td style="text-align: center">{{ row.descricao }}</td>
              <td class="actions">
                <button
                  type="button"
                  class="button button-primary"
                  v-on:click="copyBind(row.bind)"
                >
                  <fa-icon icon="copy"/>
                </button>
              </td>
            </tr>
        </template>
      </datatable>
    </div>
  </div>
</template>

<script>
import {get} from '@/helpers/apiRequest';
import _debounce from "lodash/debounce";
import {arrayFilter} from '@/helpers/utils';

export default {
  name: 'bindsList',
  data() {
    return {
      binds: [],
      termo: '',
      table: {
        columns: [
          {label: 'Variável', field: 'id', align: 'center', sortable: false},
          {label: 'Descrição', field: 'descricao', sortable: false},
          {label: '', field: '', sortable: false},
        ],
        paginator: {},
      },
    };
  },
  computed: {
    bindsFiltered() {
      if (!this.termo) {
        return this.binds;
      }
      return arrayFilter(this.binds, this.termo, ['bind', 'descricao']);
    },
  },
  methods: {
    loadBinds() {
      get(`/admin/regras-negocio/binds`)
        .then((json) => {
          this.binds = json;
        })
    },
    copyBind(bind) {
      navigator.clipboard.writeText(bind)
    },
  },
  beforeMount() {
    this.loadBinds();
  },
};
</script>

<style scoped>
.binds-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>
